import { CREATE_TRAIT, CREATING_TRAIT, GET_TRAITS, GETTING_TRAITS, TRAITS_ERROR, UPDATE_TRAIT, UPDATING_TRAIT, DELETE_TRAIT, DELETING_TRAIT, GETTING_STUDENT_TRAITS, GET_STUDENT_TRAITS, UPDATING_STUDENT_TRAITS, UPDATE_STUDENT_TRAITS } from "../types"

const initialState = {
    traits: [],
    studentTraits: [],
    loadingStudentTraits: true,
    updatingStudentTraits: false,
    updatedStudentTraits: null,
    loadingTraits: true,
    traitsError: null,
    creatingTrait: false,
    createdTrait: null,
    updatingTrait: false,
    updatedTrait: null,
    deletingTrait: false,
    deletedTrait: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_TRAITS:
        return {
            ...state,
            loadingTraits :action.payload,
        }
        case GET_TRAITS:
        return{
            ...state,
            loadingTraits:false,
            traitsError:  null,
            traits: action.payload,
        }
        case UPDATING_TRAIT:
        return {
            ...state,
            updatingTrait: action.payload,
        }
        case UPDATE_TRAIT:
        return{
            ...state,
            updatingTrait:false,
            traitsError: null,
            updatedTrait: action.payload,
        }
        case DELETING_TRAIT:
        return {
            ...state,
            deletingTrait: action.payload,
        }
        case DELETE_TRAIT:
        return{
            ...state,
            deletingTrait:false,
            traitsError: null,
            deletedTrait: action.payload,
        }
        case CREATING_TRAIT:
        return {
            ...state,
            creatingTrait: action.payload,
        }
        case CREATE_TRAIT:
        return{
            ...state,
            creatingTrait:false,
            traitsError: null,
            createdTrait: action.payload,
        }
        case GETTING_STUDENT_TRAITS:
        return {
            ...state,
            loadingStudentTraits: action.payload,
        }
        case GET_STUDENT_TRAITS:
        return{
            ...state,
            loadingStudentTraits:false,
            traitsError:  null,
            studentTraits: action.payload,
        }
        case UPDATING_STUDENT_TRAITS:
        return {
            ...state,
            updatingStudentTraits: action.payload,
        }
        case UPDATE_STUDENT_TRAITS:
        return{
            ...state,
            updatingStudentTraits:false,
            traitsError: null,
            updatedStudentTraits: action.payload,
        }
        case TRAITS_ERROR:
        return{
            ...state,
            loadingTraits:false,
            updatingTrait: false,
            updatingStudentTraits:false,
            // creatingApplication:false,
            traitsError: action.payload 
        }
        default: return state
    }

}